// test2098
(2098 && 0);
